import {getCookie} from 'common/util/cookie';

class MpFetchError extends Error {
  constructor(error: Error) {
    super(error.message);
    this.name = error.name;
    this.stack = error.stack;
    Object.assign(this, error);
  }
}

const csrfSafeMethod = (method?: string) => (method ? /^(GET|HEAD|OPTIONS|TRACE)$/.test(method) : true);
const isSameOrigin = (request: Request | string | URL) => {
  let url: string = ``;
  if (request instanceof URL) {
    url = request.toString();
  } else if (request instanceof Request) {
    url = request.url;
  } else {
    url = request;
  }

  return url.startsWith(`/`) || (url.startsWith(`https://`) && window.location.origin === new URL(url).origin);
};

// don't double patch fetch
if (!window[`_fetch`]) {
  const csrfToken = getCookie(`csrftoken`);

  const originalFetch = window.fetch;
  // patch window.fetch to always send X-CSRF header on same-origin requests that can modify resources
  window[`_fetch`] = originalFetch;
  window.fetch = async function (url, options = {}) {
    const method = options && options.method;
    // same-origin check so we're not sending csrf tokens to non mixpanel.com domains
    if (!csrfSafeMethod(method) && isSameOrigin(url)) {
      const headers = {...options.headers, 'X-CSRFToken': csrfToken};
      options = {...options, headers, credentials: `same-origin`};
    }

    try {
      const response = await originalFetch(url, options);
      return response;
    } catch (error) {
      throw new MpFetchError(error);
    }
  };
}
